module.exports = 'query GetDealer($dealerId:ID!){dealer(id:$dealerId){logo{url}}}'